import { Table, Empty } from 'antd';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import './index.scss';

interface TimeSummaryTableProps {
	searchValue?: string;
	filterValue?: any;
	yearValue?: any;
}

const TimeSummaryTable = (props: TimeSummaryTableProps) => {
	const { searchValue, filterValue, yearValue } = props;
	const { Column } = Table;
	const [columns, setColumns] = useState([]);

	const { timeSummaryData, isTimeSummaryLoading } = useSelector(
		(state: any) => state.reports
	);

	const hasActiveFilters = Boolean(
		searchValue?.trim() ||
		filterValue?.customerId?.length > 0 ||
		yearValue
	);
	// const { timeSummaryData, isTimeSummaryLoading, timeSummaryError } =
	// 	useSelector((state: any) => state.reports);

	useEffect(() => {
		if (timeSummaryData?.classNames && timeSummaryData.classNames?.length) {
			const finalColumns = timeSummaryData.classNames.map(
				(timeSummary: any) => {
					return {
						title: timeSummary,
						dataIndex: timeSummary,
					};
				}
			);

			const _columns: any = [
				{
					title: 'Employee Name',
					dataIndex: 'name',
					fixed: 'left',
				},
				...finalColumns,
				{
					title: 'Grand Total',
					dataIndex: 'totalHours',
				},
			];
			setColumns(_columns);
		}
	}, [timeSummaryData]);

	const CustomEmptyState = () => (
		<Empty
			image={Empty.PRESENTED_IMAGE_SIMPLE}
			description={
				isTimeSummaryLoading
					? null
					: hasActiveFilters
						? "No Time Summary records match the selected filter criteria"
						: "No Time Summary records are currently available"
			}
			style={{
				padding: '40px 20px',
				margin: '20px 0'
			}}
		/>
	);

	return (
		<div className="time-summary-report">
			<Table
				dataSource={timeSummaryData?.timeActivitySummary}
				scroll={{ y: '43vh' }}
				pagination={false}
				className="table-global time-summary-report-table"
				rowKey={(record: any) => {
					return record.id;
				}}
				style={{
					overflowY: 'auto',
				}}
				rowClassName={(record: any) => {
					if (record.name === 'Total') {
						return 'journal-total-row';
					}
					return '';
				}}
				loading={isTimeSummaryLoading}
				locale={{
					emptyText: <CustomEmptyState />
				}}
			>
				{columns?.map((column: any) => {
					return (
						<Column
							title={column.title}
							dataIndex={column.dataIndex}
							key={column.dataIndex}
							className={`bg-white`}
							render={(value: string) => value}
							width="200px"
							fixed={column.fixed}
						/>
					);
				})}
			</Table>
		</div>
	);
};

export default TimeSummaryTable;
